import React from "react";

export const ContinueButton = ({ onClick }) => (
  <div className="styling-wrap__btn">
    <button className="btn green" onClick={onClick}>
      Nastavi
    </button>
  </div>
);
